export * from './user-edit.component';
export * from './user-edit.service';



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/user/user-edit/index.ts